import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { getOffers } from 'shared/selectors/offers';
import { setMortgageRateHikeBannerClosedCookie } from 'shared/utils/mortgageRateHikeBannerCookie';

import { TMortgageRateHikeBannerProducts, trackBannerClick, trackBannerShow } from './tracking';
import { MortgageRateHikeBanner } from '../../components/MortgageRateHikeBanner';

export const MortgageRateHikeBannerContainer: React.FC = () => {
  const offers = useSelector(getOffers);
  const [isClosed, setIsClosed] = React.useState(false);

  const products = React.useMemo<TMortgageRateHikeBannerProducts>(
    () =>
      offers.map((offer, index) => ({
        id: offer.id,
        offerType: 'offer',
        position: index + 1,
      })),
    [offers],
  );

  const handleShow = React.useCallback(() => {
    trackBannerShow(products);
  }, [products]);

  const handleButtonClick = React.useCallback(() => {
    trackBannerClick(products);
    setMortgageRateHikeBannerClosedCookie();
    setIsClosed(true);
  }, [products]);

  if (isClosed) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={handleShow} triggerOnce>
      <MortgageRateHikeBanner onButtonClick={handleButtonClick} />
    </ActionAfterViewObserver>
  );
};
